import API from "./api";

const TraductionVerificationService = {
  getAll: async (verificationId: number) => {
    const response = await API.get(`/verif/${verificationId}/traductions`);
    return response.data.donnees;
  },

  getByLangue: async (verificationId: number, langue: string) => {
    const response = await API.get(
      `/verif/${verificationId}/traductions/${langue}`,
    );
    return response.data.donnees;
  },

  create: async (verificationId: number, payload: any) => {
    const response = await API.post(
      `/verif/${verificationId}/traductions`,
      payload,
    );
    return response.data.donnees;
  },

  update: async (id: number, payload: any) => {
    const response = await API.put(
      `/verif/traductions-verifications/${id}`,
      payload,
    );
    return response.data.donnees;
  },

  delete: async (id: number) => {
    const response = await API.delete(`/verif/traductions-verifications/${id}`);
    return response.data.donnees;
  },
};

export default TraductionVerificationService;
